import { useEffect } from 'react';
import { ILLER } from '../../utils/turkeyData';
import { Select, Input } from './Input';

/**
 * AddressPicker
 * Props:
 *   value: { city, district, address_detail }
 *   onChange: (newValue) => void
 *   error: string | undefined
 */
export function AddressPicker({ value = {}, onChange, error }) {
  const { city = '', district = '', address_detail = '' } = value;

  const ilData = ILLER.find(i => i.name === city);
  const ilceler = ilData ? ilData.ilceler : [];

  const set = (key) => (e) => {
    const next = { ...value, [key]: e.target.value };
    if (key === 'city') {
      next.district = '';
    }
    onChange(next);
  };

  // If current district is not in new ilceler list, reset it
  useEffect(() => {
    if (city && district && ilceler.length > 0 && !ilceler.includes(district)) {
      onChange({ ...value, district: '' });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [city]);

  return (
    <div className="space-y-3">
      <div className="grid grid-cols-2 gap-3">
        <Select label="İl" value={city} onChange={set('city')} error={error && !city ? error : undefined}>
          <option value="">— İl seçin —</option>
          {ILLER.map(i => (
            <option key={i.id} value={i.name}>{i.name}</option>
          ))}
        </Select>

        <Select label="İlçe" value={district} onChange={set('district')} disabled={!city}>
          <option value="">— İlçe seçin —</option>
          {ilceler.map(ilce => (
            <option key={ilce} value={ilce}>{ilce}</option>
          ))}
        </Select>
      </div>

      <Input
        label="Açık Adres (Cadde / Sokak / No)"
        value={address_detail}
        onChange={set('address_detail')}
        placeholder="Örn: Atatürk Cad. No:5 D:3"
        error={error && city && district && !address_detail ? error : undefined}
      />

      {error && !city && (
        <p className="text-xs text-red-500">{error}</p>
      )}
    </div>
  );
}

/**
 * Build a full address string from structured parts
 */
export function buildFullAddress({ city, district, address_detail }) {
  return [address_detail, district, city].filter(Boolean).join(', ');
}
